/**
 * 全局数据源、指标 key常量配置
 * 后续新增数据源、指标，可以统一在这个配置文件新增
 * 页面需要用到 数据源、指标 作为判断的时候，可以统一从该配置文件引用对应的数据源、指标
 */

// 数据源key常量映射
export const SOURCE_KEY_MAP: {
  [key: string]: string;
} = {
  GSD: 'gsd',
};

/**
 * 数据源key与指标key常量映射的map映射
 * 键为数据源key，值为指标key常量映射
 * 避免不同数据源下 存在 相同指标，但是指标的key不同的场景，所以每个数据源的指标key映射 都是独立的
 */
export const METRIC_KEY_MAP: {
  [key: string]: {
    [key: string]: string;
  };
} = {
  [SOURCE_KEY_MAP.GSD]: {
    DIGITAL_UNITS: 'gsd_digitalUnits',
    PHYSICAL_UNITS: 'gsd_physicalUnits',
    DIGITAL_REVENUE: 'gsd_digitalRevenue',
    PHYSICAL_REVENUE: 'gsd_physicalRevenue',
  },
};

/**
 * 获取指定数据源key对应的指标key映射
 * @param source 数据源key
 * @returns 指标key映射
 */
export const getMetricKeyMap = (
  source: string,
): {
  [key: string]: string;
} => {
  return METRIC_KEY_MAP[source] || {};
};

// GSD数据源
export const GSD_SOURCE_KEY = SOURCE_KEY_MAP.GSD;
// GSD数据源指标key映射
export const GSD_METRIC_KEY_MAP = getMetricKeyMap(GSD_SOURCE_KEY);
// GSD数据源指标集合
export const GSD_DATASOURCE_METRICS = [
  { dataSource: GSD_SOURCE_KEY, metric: GSD_METRIC_KEY_MAP.DIGITAL_UNITS },
  { dataSource: GSD_SOURCE_KEY, metric: GSD_METRIC_KEY_MAP.PHYSICAL_UNITS },
  { dataSource: GSD_SOURCE_KEY, metric: GSD_METRIC_KEY_MAP.DIGITAL_REVENUE },
  { dataSource: GSD_SOURCE_KEY, metric: GSD_METRIC_KEY_MAP.PHYSICAL_REVENUE },
];
// GSD数据源指标value集合（下载弹窗的级联指标筛选器专用）
export const GSD_CASCADER_METRICS = [
  [GSD_SOURCE_KEY, GSD_METRIC_KEY_MAP.DIGITAL_UNITS],
  [GSD_SOURCE_KEY, GSD_METRIC_KEY_MAP.PHYSICAL_UNITS],
  [GSD_SOURCE_KEY, GSD_METRIC_KEY_MAP.DIGITAL_REVENUE],
  [GSD_SOURCE_KEY, GSD_METRIC_KEY_MAP.PHYSICAL_REVENUE],
];
